import React from 'react'
import { useRecoilValue } from 'recoil';
import { permissionsSelector } from '../../../Login/selectors/permissionSelector';
import { PERMISSIONS } from '../../../PermissionsConstants';
import AlarmTypeTable from './view/AlarmTypeTable';

interface AlarmTypeProps {}
export const AlarmType: React.FC<AlarmTypeProps> = () => {
    const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_alarmtype_view;
    const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <AlarmTypeTable/>} </>
  );
};
export default AlarmType;